import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import { useNavigate } from "react-router-dom";
import Loader3 from "../Loader3/Loader3";
import { useDispatch, useSelector } from "react-redux";
import VideoItem from "./VideoItem";
import Pagination from "@mui/material/Pagination";

const Video = ({ hideAddButton, hideTags }) => {
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(false);
  // eslint-disable-next-line
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [showTags, setShowTags] = useState(false);

  const {
    video: {
      filteredVideos,
      videos,
      pagination: { startIndex, endIndex, count },
    },
  } = useSelector(state => state.appairerVisuels);

  const handleChangePage = (event, value) => {
    event.stopPropagation();

    dispatch({
      type: "SET_END_INDEX_PAGINATION_VIDEOS_APPARIEMENT_VISUELS",
      payload: value * count,
    });
  };

  const addVideo = () => {
    navigate("/creation-package-pub/ajout-ressource");
  };

  const filterVideos = e => {
    dispatch({
      type: "FILTER_VIDEOS_APPARIEMENT_VISUELS",
      payload: e.target.value,
    });
  };

  const videosToShow = filteredVideos.slice(startIndex, endIndex);

  return (
    <section className='section section_video'>
      <header
        onClick={() => setToggle(prevState => !prevState)}
        className='section_header'
      >
        <div className='df'>
          <h3 className='section_header_title'>Video</h3>
        </div>
        <i className={`fas fa-chevron-${toggle ? "up" : "down"}`}></i>
      </header>
      {toggle && (
        <div className='section_content'>
          <div className='search_tags'>
            <div className='search'>
              <i className='fas fa-search'></i>
              <input
                onChange={filterVideos}
                type='search'
                name=''
                id=''
                placeholder='Search'
              />
            </div>
            {!hideTags && (
              <div className='tags'>
                <i className='fas fa-info-circle'></i>
                <p>Tags</p>
                <Switch
                  onChange={() => setShowTags(prevState => !prevState)}
                  checked={showTags}
                />
              </div>
            )}
          </div>
          <div className='list_videos'>
            {loader ? (
              <Loader3 />
            ) : videosToShow && videosToShow.length > 0 ? (
              videosToShow.map(video => (
                <VideoItem key={video.id} showTags={showTags} video={video} />
              ))
            ) : (
              <h4>Aucune vidéo pour l'instant</h4>
            )}

            {!hideAddButton && (
              <div onClick={addVideo} className='video_item add_image_item'>
                <img src='/add_image_icon.png' alt='' />
              </div>
            )}
          </div>
          <div className='pagination'>
            {/* {paginationElements.map(item => (
              <span>{item}</span>
            ))} */}
            <Pagination
              count={parseInt(videos.length / count) + 1}
              onChange={handleChangePage}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Video;
